var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarDates = function SvgCalendarDates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2 2 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6H6V5H4v3h16V5h-2v1h-2V5H8v1Zm12 4H4v10h16V10Zm-4-7H8V2H6v1H4a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2V2h-2v1ZM7 14v-2h2v2H7Zm4 0h2v-2h-2v2Zm4 0v-2h2v2h-2Zm-8 2v2h2v-2H7Zm6 2h-2v-2h2v2Z",
    fill: "var(--c-blue)"
  })));
};
export default SvgCalendarDates;